// extracted by mini-css-extract-plugin
export default {"container":"Instructions_container__RGB5t"};